import {
  CLOSED_USER_CREATION_WARNING_FORM,
  RedirectPaths,
  RedirectPathsEnum,
} from '@/common/constants';
import { DialogContext } from '@/common/context';
import { usePlanners } from '@/hooks/query/planner.hooks';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import { DialogType } from '@/system-settings/enums';
import { showBlockEmailsMessage } from '@/utils/helpers';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const useCreateUserRedirect = (): (() => void) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { setDialogData } = useContext(DialogContext);

  const { planners } = usePlanners(
    {
      skip: 0,
      take: 0,
    },
    currentAccount?.id,
  );

  return () => {
    const redirect = () =>
      navigate(RedirectPaths[RedirectPathsEnum.USERS_CREATE]());

    const shouldWarn =
      !localStorage.getItem(CLOSED_USER_CREATION_WARNING_FORM) &&
      planners?.count &&
      !showBlockEmailsMessage(currentAccount);

    if (!shouldWarn) {
      redirect();

      return;
    }

    setDialogData({
      show: true,
      type: DialogType.WARNING,
      header: t('dialog.enrollment.warning.heading'),
      message: t('dialog.enrollment.warning'),
      confirmationMessage: t('dialog.enrollment.doNotShow'),
      confirmationConst: CLOSED_USER_CREATION_WARNING_FORM,
      showDialogConfirmation: true,
      onAccept: redirect,
    });
  };
};
